//store.jsx
import { combineReducers, createStore } from "redux";
import userReducer from "./userdetails";

const rootReducer = combineReducers(
  {
    user: userReducer
  }
)

const store = createStore(rootReducer)
/* 
store.subscribe( () => {
    console.log(  store.getState() )} ) */

export default store